import { Button, Modal, Spin } from 'antd';

import styles from './DeleteConfirmationModal.module.scss';

type TProps<T> = {
  isModalOpen: boolean;
  handleOk: VoidFunction;
  handleCancel: VoidFunction;
  title: string;
  description: string;
  itemToOperate: null | T;
  shouldDisableElement: boolean;
};

export const DeleteConfirmationModal = <T,>({
  isModalOpen,
  handleOk,
  handleCancel,
  title,
  description,
  shouldDisableElement,
}: TProps<T>) => (
  <Modal
    width={600}
    open={isModalOpen}
    onCancel={handleCancel}
    footer={null}
    centered
  >
    <Spin spinning={shouldDisableElement}>
      <div className={styles.wrapper}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
        <div className={styles['buttons-wrapper']}>
          <Button
            size="large"
            onClick={handleOk}
            className={styles.button}
            danger
            disabled={shouldDisableElement}
          >
            Удалить
          </Button>
          <Button
            size="large"
            onClick={handleCancel}
            type="primary"
            className={styles.button}
          >
            Отмена
          </Button>
        </div>
      </div>
    </Spin>
  </Modal>
);
